import { createWebHistory, createRouter } from 'vue-router'
import App from '../App.vue';

const routes = [
	{ path: '/', component: App },
	{ path: '/login', component: App },
	{ path: "/reset-password", component: App },
	{ path: '/contact-us', component: App },
	{ path: '/military-shipment', component: App },
	{ path: '/military-shipment/:uuid', component: App },
	{ path: '/consumer-shipment', component: App },
	{ path: '/consumer-shipment/:uuid', component: App },
	{ path: '/admin/container-types', component: App },
	{ path: '/admin/service-types', component: App },
	{ path: '/admin/ports-agents', component: App },
	{ path: '/admin/users', component: App },
	{ path: '/admin/partners', component: App},
	{ path: '/admin/config', component: App },
	{ path: '/me/contact-us', component: App },
	{ path: '/:pathMatch(.*)*', component: App }
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});
export default router;
